/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InterventionPlanningResource } from '../models/InterventionPlanningResource';
import type { RdvResource } from '../models/RdvResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class EquipeService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Ou sont les commerciaux ?
     * Les rendez-vous en cours a l'instant `time` (maintenant par defaut), avec l'adresse, le projet, le client et les personnels affectes. Sert a la carte de l'equipe.
     * @param time
     * @returns RdvResource Array of `RdvResource`
     * @throws ApiError
     */
    public equipeLocalisationPersonnelRendezVous(
        time: string,
    ): CancelablePromise<Array<RdvResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/equipe/localisation/rdv',
            query: {
                'time': time,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Ou sont les techniciens ?
     * Les creneaux d'intervention en cours a l'instant `time` (maintenant par defaut), avec l'intervention, le projet, le client, l'adresse de chantier et les techniciens affectes. Sert a la carte de l'equipe.
     * @param time
     * @returns InterventionPlanningResource Array of `InterventionPlanningResource`
     * @throws ApiError
     */
    public equipeLocalisationPersonnelIntervention(
        time: string,
    ): CancelablePromise<Array<InterventionPlanningResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/equipe/localisation/intervention',
            query: {
                'time': time,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
}
